import React, { useEffect, useState } from "react";

const MSGS = [
  "Pre-orders now open — limited first drop",
  "Sign up for 15% off your first order",
];

export const AnnouncementBar = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % MSGS.length), 3800);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="bg-cream text-bg" data-testid="announcement-bar">
      <div className="h-8 flex items-center justify-center overflow-hidden">
        <span key={i} className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.25em] animate-in fade-in duration-500">
          {MSGS[i]}
        </span>
      </div>
    </div>
  );
};
